import React, { useEffect, useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { QuoteRouteV2Id } from 'routes/routesConfigV2';
import QuoteFlowLayout from 'components/common/quote/QuoteFlowLayout';
import { useQuoteDomainParams } from 'global/hooks/useQuoteDomainParams';
import DDWAQuoteProposalInfoPageStore, {
  DDWAQuoteProposalInfoPageStoreContext,
  useDDWAQuoteProposalInfoPageStore,
} from 'store/pages/quote/quote-proposal-info/ddwa/pageStore';
import DDWAQuoteProposalInfoForm from 'components/quote/quote-proposal-info/DDWA';

// TESTING_POLICY: CYPRESS_ONLY

const PageContent: React.FC = observer(() => {
  const { isActionLoading, flowDelegate, canCompleteStep, onComplete, getInitialData } =
    useDDWAQuoteProposalInfoPageStore();

  useEffect(() => {
    void getInitialData();
  }, []);

  return (
    <QuoteFlowLayout
      flowDelegate={flowDelegate}
      pageId={QuoteRouteV2Id.QUOTE_PROPOSAL_INFO}
      isPageLoading={flowDelegate.isInitialDataLoading}
      isActionLoading={isActionLoading}
      pageHeader={{ subtitleMaxWidth: '50rem' }}
      pageFooter={{
        onComplete,
        completeButtonText: 'Save',
        disableCompleteButton: !canCompleteStep,
      }}
    >
      <DDWAQuoteProposalInfoForm />
    </QuoteFlowLayout>
  );
});

const DDWAQuoteProposalInfoPage: React.FC = () => {
  const { groupId, periodId, cartId } = useQuoteDomainParams();

  const pageStore = useMemo(
    () => new DDWAQuoteProposalInfoPageStore({ groupId, periodId, cartId }),
    [groupId, periodId, cartId],
  );

  return (
    <DDWAQuoteProposalInfoPageStoreContext.Provider value={pageStore}>
      <PageContent />
    </DDWAQuoteProposalInfoPageStoreContext.Provider>
  );
};

export default DDWAQuoteProposalInfoPage;
